import { useEffect, useState, useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { formatDateForUrl, DateFilters } from '../utils/dateUtils'

export interface ChartFilters extends DateFilters {}

export const useUrlFilters = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [filters, setFilters] = useState<ChartFilters>(() => {
    // Initialize with default values
    const currentDate = new Date()
    const thirtyDaysAgo = new Date(
      currentDate.getTime() - 30 * 24 * 60 * 60 * 1000,
    )

    return {
      start_date: thirtyDaysAgo,
      end_date: currentDate,
    }
  })

  // Load filters from URL on mount
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const start_date = searchParams.get('start_date')
    const end_date = searchParams.get('end_date')

    if (start_date && end_date) {
      setFilters({
        start_date: new Date(start_date),
        end_date: new Date(end_date),
      })
    }
  }, [location.search])

  // Update URL when filters change
  const updateFilters = useCallback(
    (newFilters: ChartFilters) => {
      setFilters(newFilters)

      // Update URL query parameters
      const searchParams = new URLSearchParams(location.search)

      searchParams.set('start_date', formatDateForUrl(new Date(newFilters.start_date)))
      searchParams.set('end_date', formatDateForUrl(new Date(newFilters.end_date)))

      navigate(`${location.pathname}?${searchParams.toString()}`, {
        replace: true,
      })
    },
    [location.search, location.pathname, navigate],
  )

  return { filters, updateFilters }
}
